import { formatDuration } from '@shared/lib/date';
import IconPause from '@assets/img/icons/pause-circle.svg';
import IconPhoneIncoming from '@assets/img/icons/phone-incoming.svg';
import IconPhoneMissed from '@assets/img/icons/phone-missed.svg';
import IconPhoneOutgoing from '@assets/img/icons/phone-outgoing.svg';

import type { CallInfo, CallState } from '../model/types';

/**
 * Возвращает человеко читаемую строку-статус для отображения в UI.
 *
 * - **Принятый звонок** (`endedAt` > 0) → строка длительности из {@link formatDuration}.
 * - **Входящий без длительности** → «Пропущен».
 * - **Исходящий без длительности** → «Нет ответа».
 *
 * @param  callInfo  Информация о конкретном звонке.
 * @param  short  Флаг кроткое инфо.
 * @returns Готовый текст статуса.
 */
export const formatCallStatus = (callInfo: CallInfo, short = false): string => {
	if (callInfo.endedAt && callInfo.startedAt) {
		return `${short ? '' : 'Длительность: '}${formatDuration(callInfo.startedAt, callInfo.endedAt)}`;
	}

	return callInfo.direction === 'incoming' ? 'Пропущен' : 'Нет ответа';
};

/**
 * Возвращает подходящую иконку для состояния звонка с учётом направления.
 *
 * @param state Текущее состояние звонка.
 * @param isIncomingCall Флаг входящего звонка.
 * @returns SVG-иконка состояния.
 */
export const getStateIcon = (state: CallState, isIncomingCall: boolean) => {
	let stateIcon = isIncomingCall ? IconPhoneIncoming : IconPhoneOutgoing;

	switch (state) {
		case 'declined': {
			stateIcon = IconPhoneMissed;
			break;
		}
		case 'hold':
		case 'remoteHold':
		case 'parked': {
			stateIcon = IconPause;
			break;
		}
		default: {
			break;
		}
	}

	return stateIcon;
};
